import { lazy } from 'react';

const Dashboard = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Providers: lazy(() => import('./components/Providers.tsx')),
  Dashboard: lazy(() => import('./containers/Dashboard/index.tsx')),
  Documents: lazy(() => import('./containers/Documents/index.tsx')),
};

export default Dashboard;
